import { render } from "./StandartRadio.vue?vue&type=template&id=17151c2d&scoped=true"
import script from "./StandartRadio.vue?vue&type=script&lang=js"
export * from "./StandartRadio.vue?vue&type=script&lang=js"

import "./StandartRadio.vue?vue&type=style&index=0&id=17151c2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17151c2d"]])

export default __exports__